/** @module                 React */

import { useState }         from "react";

/** @module                 Router */

import { useNavigate }      from "react-router-dom";

/** @module                 Apollo */

import { useMutation }      from "@apollo/client";

import { CREATE_SERVICE }   from "../../Mutations/Services";

const 

/** 
 * 
 * @returns useCreateService hook for creating new service
 * 
 */

useCreateService = () => { const 

    /** @hooks */

    navigate = useNavigate (),

    [ loading,  setLoading  ] = useState ( false ),

    [ errors,   setErrors   ] = useState ( false ),

    /** @mutations */

    [ CreateService ] = useMutation ( CREATE_SERVICE, {

        /** @event onComplete */

        onCompleted ( data ) {

            setLoading ( false );

            return navigate ( `/app/content/services/edit/${ data.adminCreateService.service.id }` );

        },

        /** @event onError */

        onError ( err ) { setLoading ( false ); setErrors ( true ); }

    } ),

    /** 
     * 
     * @param { String } title
     * 
     * @param { String } content
     * 
     * @param { Boolean } isActive
     * 
     * @param { Boolean } tiremarketOnly
     * 
     * @param { String } language
     * 
     * @returns create service action
     * 
     */

    createService = ( title, content, image, isActive, tiremarketOnly, language ) => {

        /** @validation */

        setErrors ( false ); setLoading ( true );

        if ( ! title || ! content ) {

            setErrors   ( true  );

            setLoading  ( false );

            return;

        };

        /** @mutation */

        CreateService ( { variables: {

            title,

            content,

            image,

            isActive,

            tiremarketOnly,

            language
    
        } } );

    }

    /** @returns */

    return { createService, loading, errors }

};

/** @exports useCreateService */

export default useCreateService;